export default "__VITE_ASSET__D43YlQV2__"